import React from 'react';
import { companyInfo, navigation } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer py-16">
      <div className="container-custom">
        {/* Top Section */}
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-16 w-auto object-contain mb-6"
            />
            <p 
              className="text-sm"
              style={{ 
                color: 'var(--text-muted)',
                lineHeight: '1.7'
              }}
            >
              A privately held investment firm focused on acquiring, operating, and managing essential businesses with a long-term ownership mindset.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-1">
            <h4 
              className="text-lg font-semibold mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Quick Links
            </h4>
            <nav className="grid grid-cols-2 gap-3">
              {navigation.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-sm text-left bg-transparent border-none cursor-pointer transition-colors duration-300 hover:text-[var(--accent-gold)]"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => scrollToSection('legal')}
                className="text-sm text-left bg-transparent border-none cursor-pointer transition-colors duration-300 hover:text-[var(--accent-gold)]"
                style={{ color: 'var(--text-muted)' }}
              >
                Legal
              </button>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="md:col-span-1">
            <h4 
              className="text-lg font-semibold mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Contact
            </h4>
            <div className="space-y-3">
              <p 
                className="text-sm"
                style={{ color: 'var(--text-muted)' }}
              >
                {companyInfo.contact.address}
              </p>
              <p>
                <a 
                  href={`mailto:${companyInfo.contact.email}`}
                  className="text-sm transition-colors duration-300 hover:text-[var(--accent-gold)]"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {companyInfo.contact.email}
                </a>
              </p>
              <p>
                <a 
                  href={`tel:${companyInfo.contact.phone}`}
                  className="text-sm transition-colors duration-300 hover:text-[var(--accent-gold)]"
                  style={{ color: 'var(--text-muted)' }}
                >
                  {companyInfo.contact.phone}
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="divider-gold mb-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p 
            className="text-sm"
            style={{ color: 'var(--text-muted)' }}
          >
            © {currentYear} AA Khwaja Investments LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <button
              onClick={() => scrollToSection('legal')}
              className="text-sm bg-transparent border-none cursor-pointer transition-colors duration-300 hover:text-[var(--accent-gold)]"
              style={{ color: 'var(--text-muted)' }}
            >
              Privacy Policy
            </button>
            <button
              onClick={() => scrollToSection('legal')}
              className="text-sm bg-transparent border-none cursor-pointer transition-colors duration-300 hover:text-[var(--accent-gold)]"
              style={{ color: 'var(--text-muted)' }}
            >
              Terms of Use
            </button>
            <button
              onClick={() => scrollToSection('legal')}
              className="text-sm bg-transparent border-none cursor-pointer transition-colors duration-300 hover:text-[var(--accent-gold)]"
              style={{ color: 'var(--text-muted)' }}
            >
              Disclaimer
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
